.main {
  display: flex;
  flex-direction: column;
  padding-top: 8px;
}

.main__redesign {
  padding: 0 24px 24px;
}

.breadcrumbs__redesign {
  margin-top: 8px;
}

.bannerContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--colors-grays-light);
}

.bannerContainer--noImg {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--colors-grays-light);
  border-top: 1px solid var(--colors-grays-light);
  height: auto;
  padding: 24px;
}

.imgContainer {
  display: flex;
  height: 177px;
  width: 100%;
}

.img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 0;
}

.detailsContainer {
  display: flex;
  flex-direction: column;
}

.detailsContainer--withImage {
  padding: 24px;
}

.detailsTitle {
  margin-bottom: 8px;
  font-size: 24px;
}

.specialType {
  color: var(--colors-info-main);
}

.description {
  max-width: 826px;
}

.breadcrumbs {
  margin-bottom: 16px;
  margin-left: 16px;
  margin-top: 8px;
}

.dealsButtons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 8px;
}

.productCount {
  margin-top: 16px;
  margin-bottom: 8px;
  margin-left: 16px;
}

.termsAndConditionsLink {
  margin-bottom: 8px;
}

.termsModal {
  height: auto;
  max-height: 400px;
  padding: 40px;
}

.termsModal__header {
  box-shadow: none;
  padding: 0;
  min-height: auto;
  margin-bottom: 24px;
}

.termsModal__header > div {
  flex-direction: row-reverse;
}

.termsModal__header > div > div {
  margin: 0;
}

.termsModal__content {
  padding: 0;
}

@media all and (--reefer-media-tablet-min) {
  .main {
    margin-left: 64px;
    margin-right: 64px;
    padding-top: 12px;
  }

  .main__redesign {
    padding: 0 64px 48px;
  }

  .breadcrumbs__redesign {
    margin-top: 16px;
    margin-left: 0;
  }

  .breadcrumbs {
    margin-bottom: 20px;
    margin-top: 0px;
  }

  .bannerContainer {
    flex-direction: row;
    border: none;
    height: 212px;
    margin-bottom: 24px;
  }

  .bannerContainer--noImg {
    border: none;
    margin-bottom: 24px;
    padding: 0;
  }

  .img {
    aspect-ratio: 2.11 / 1;
    border-radius: 24px;
    width: unset;
  }

  .detailsContainer {
    padding-top: 8px;
  }

  .detailsContainer--withImage {
    padding: 0 0 0 40px;
  }

  .detailsTitle {
    margin-bottom: 0;
    font-size: var(--typography-title-bold-font-size-desktop);
  }

  .specialType--withImage {
    margin-top: 8px;
  }

  .imgContainer {
    height: 100%;
    width: unset;
  }

  .dealsButtons {
    margin-top: 0;
  }

  .productCount {
    margin-left: 0;
  }
}

@media all and (--reefer-media-tablet-max) {
  .termsModal {
    position: fixed;
    top: unset;
    bottom: 0;
    left: 50%;
    right: 50%;
    transform: translateX(-50%);
    max-width: 100%;
    height: auto;
    max-height: 60vh;
    border-radius: var(--border-radius-lg) var(--border-radius-lg) 0 0;
    padding: 24px;
  }
}
